export default __webpack_public_path__ + "static/media/udaipur.2ce38e64.jpg";